import { z } from 'zod';
// ─── Request Schemas ─────────────────────────────────────────────────────────
export const StepAnalyticsQuerySchema = z.object({
    startDate: z.string().date(),
    endDate: z.string().date(),
});
export const CourseAnalyticsParamSchema = z.object({
    courseId: z.string().uuid(),
});
// ─── Lesson Analytics ───────────────────────────────────────────────────────
export const LessonAnalyticsParamSchema = z.object({
    lessonId: z.string().uuid(),
});
//# sourceMappingURL=analytics.schema.js.map